<form [formGroup]="form" class="needs-validation">
  <div class="position-relative row form-group">
    <label for="name_Id" class="col-sm-2 col-form-label"
      >{{ "Form.NAME" | translate }} <span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-12">
      <input
        formControlName="name"
        name="name"
        id="name_Id"
        type="text"
        class="form-control"
        placeholder="Tooltip name"
        required
        [readonly]="currentTooltip.parentId"
      />
      <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
        <div *ngIf="f.name.errors.required">
          {{ "Form.Error.NAME" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex mb-2 mt-2 justify-content-end">
    <button
      style="
        border: none;
        border-radius: 50px;
        background-color: rgb(255, 238, 0);
        width: 25px;
        height: 25px;
        text-align: center;
      "
      (click)="generateContentForTooltip()"
    >
      <i
        id="suggest-workflow-step"
        style="font-size: 18px"
        class="fa fa-lightbulb-o"
        title="Enhance Tooltip with AI"
      ></i>
    </button>
  </div>
  <div class="position-relative row form-group">
    <label for="hint" class="col-sm-2 col-form-label"
      >{{ "Form.Text" | translate }}<span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group mb-2 pb-2">
    <div class="col-md-12">
      <angular-editor
        formControlName="hint"
        [config]="config"
        required
      ></angular-editor>
      <div
        *ngIf="submitted && f.hint.errors"
        style="margin-bottom: 0; color: red; font-size: small"
      >
        <div *ngIf="f.hint.errors.required">
          {{ "Form.TextERR" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="position-relative row form-group">
    <label for="elementSelector" class="col-sm-2 col-form-label"
      >{{ "Form.ElementSelector" | translate
      }}<span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-10">
      <select
        id="elementSelector"
        class="form-control"
        name="elementSelector"
        formControlName="elementSelector"
      >
        <option value="">Select Element Identifier</option>
        <option value="Id">Id</option>
        <option value="Class">Class</option>
        <option value="Path">Path</option>
        <option value="Name">Name</option>
        <option value="TagName">Tag Name</option>
        <option value="XPath">XPath</option>
      </select>
      <div
        *ngIf="submitted && f.elementSelector.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.elementSelector.errors.required">
          {{ "Form.ElementSelectorErr" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="position-relative row form-group">
    <label for="element" class="col-sm-2 col-form-label"
      >{{ "Form.Element" | translate }}<span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-10">
      <input
        formControlName="element"
        name="element"
        id="element"
        type="text"
        class="form-control"
      />
      <div *ngIf="submitted && f.element.errors" class="invalid-feedback">
        <div *ngIf="f.element.errors.required">
          {{ "Form.ElementErr" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div
    class="position-relative row form-group"
    *ngIf="!currentTooltip.parentId"
  >
    <label for="hintPosition" class="col-sm-2 col-form-label"
      >{{ "Form.IconPosition" | translate
      }}<span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-10">
      <select
        formControlName="hintPosition"
        type="select"
        id="hintPosition"
        name="hintPosition"
        class="custom-select"
      >
        <option value="middle-right">{{ "Form.Right" | translate }}</option>
        <option value="middle-left">{{ "Form.Left" | translate }}</option>
      </select>
    </div>
  </div>

  <div
    class="position-relative row form-group"
    *ngIf="!currentTooltip.parentId"
  >
    <label for="position" class="col-sm-2 col-form-label"
      >{{ "Form.TooltipPosition" | translate
      }}<span class="text-danger">*</span></label
    >
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-10">
      <select
        formControlName="position"
        type="select"
        id="position"
        name="position"
        class="custom-select"
      >
        <option value="right">{{ "Form.Right" | translate }}</option>
        <option value="bottom">{{ "Form.Bottom" | translate }}</option>
        <option value="top">{{ "Form.Top" | translate }}</option>
        <option value="left">{{ "Form.Left" | translate }}</option>
      </select>
    </div>
  </div>

  <div
    class="position-relative row form-group mb-1 pb-1"
    *ngIf="!currentTooltip.parentId"
  >
    <label for="position" class="col-sm-2 col-form-label">
      {{ "Form.TooltipCSS" | translate }}
    </label>
  </div>
  <div class="position-relative row form-group">
    <div class="col-sm-10">
      <textarea
        id="icon-style"
        class="form-control"
        rows="4"
        cols="50"
        name="style"
        formControlName="tooltipCSS"
      >
      </textarea>
    </div>
  </div>
  <div class="position-relative row form-group mb-2 pb-2">
    <label for="position" class="col-sm-2 col-form-label">
      {{ "Form.SRoles" | translate }}
    </label>
  </div>
  <div class="position-relative row form-group">
    <ng-select
      [items]="roles"
      [virtualScroll]="true"
      bindLabel="displayname"
      bindValue="name"
      placeholder="{{ 'Form.SRoles' | translate }}"
      [(ngModel)]="currentTooltip.roles"
      class="ms-1 mt-0 col-4"
      [multiple]="true"
      formControlName="roles"
      (change)="onSelectionChange($event)"
    >
    </ng-select>
  </div>

  <div class="position-relative row form-check mt-2 pt-2 pl-2">
    <div class="col-sm-12">
      <button
        class="btn"
        style="margin-right: 10px"
        type="submit"
        [disabled]="!form.dirty"
        [ngClass]="{
          'btn-primary': form.dirty,
          'btn-secondary': !form.dirty
        }"
        (click)="onSubmit()"
      >
        {{ "Form.PublishToDev" | translate }}
      </button>
      <button
        class="btn reset-btn"
        [disabled]="!form.dirty"
        (click)="onReset()"
      >
        {{ "Form.CANCEL" | translate }}
      </button>
      <button
        class="btn btn-secondary"
        [ngClass]="{
          'btn-primary': !form.dirty && publishToQA,
          'btn-secondary': form.dirty || !publishToQA
        }"
        [disabled]="form.dirty || !publishToQA"
        style="margin-right: 10px; margin-left: 10px"
        (click)="onClickOfPublish('qa'); form.markAsPristine()"
      >
        {{ "Form.PublishToQA" | translate }}
      </button>
      <button
        class="btn btn-secondary"
        [ngClass]="{
          'btn-primary': (!form.dirty || publishToProd) && !publishToQA,
          'btn-secondary': form.dirty || !publishToProd
        }"
        [disabled]="form.dirty || !publishToProd"
        (click)="onClickOfPublish('prod')"
      >
        {{ "Form.PublishToProd" | translate }}
      </button>
    </div>
  </div>

  <div class="divider"></div>
</form>

<div
  class="card-header-tab card-header"
  style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
>
  <div class="card-title font-size-md text-capitalize">
    {{ "Form.SELECT_LANGUAGE_TANS" | translate }}
  </div>
</div>

<div
  class="row"
  *ngIf="project && project.supportedLanguage"
  style="margin-left: -5px"
>
  <div
    style="
      padding: 10px;
      cursor: pointer;
      margin-bottom: 4px;
      font-size: 11px;
      height: fit-content;
    "
    class="badge ms-2 col-md-1"
    [ngClass]="{
      'badge-primary': currentTooltip.languageId == project.primaryLanguage,
      'badge-secondary': currentTooltip.languageId != project.primaryLanguage
    }"
    (click)="showSelectedLangaugeTooltip(project.primaryLanguage)"
  >
    {{ getLanguageName(project.primaryLanguage) }}
  </div>
  <ng-container *ngFor="let psl of project.supportedLanguage">
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 11px;
        height: fit-content;
      "
      *ngIf="psl.id != project.primaryLanguage"
      class="badge ms-2 col-md-1"
      [ngClass]="{
        'badge-primary': psl.id == currentTooltip.languageId,
        'badge-secondary': psl.id != currentTooltip.languageId
      }"
      (click)="showSelectedLangaugeTooltip(psl.id)"
    >
      {{ psl.name }}
    </div>
  </ng-container>

  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">{{ "Form.SELECT_NEW_LANGUAGE" | translate }}</h4>
      <button
        type="button"
        class="close mt-2"
        aria-label="Close"
        (click)="d('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body lang-popup">
      <overlay-scrollbars [defer]="true">
        <mat-selection-list #newLanguages class="me-2">
          <mat-list-option *ngFor="let projectSl of getNewLanguage()">
            {{ projectSl.name }}
          </mat-list-option>
        </mat-selection-list>
      </overlay-scrollbars>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn reset-btn" (click)="c('Close click')">
        {{ "Form.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveNewSelectedLanguage(newLanguages)"
      >
        {{ "Form.SAVE" | translate }}
      </button>
    </div>
  </ng-template>
  <div
    style="
      padding: 10px;
      cursor: pointer;
      margin-bottom: 4px;
      font-size: 11px;
      height: fit-content;
    "
    class="badge ms-2 badge-primary col-md-1"
    (click)="open(content)"
  >
    +
  </div>
</div>

<div
  class="card-header-tab card-header"
  style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
  *ngIf="currentTooltip.updatedAt"
>
  <div class="card-title font-size-md text-capitalize">
    {{ "Form.Lastupdatedon" | translate }}
    {{ currentTooltip.updatedAt | date : "dd-MM-yyyy HH:mm a z" }}
  </div>
</div>
